export default "__VITE_ASSET__e009bb6a__"